import { useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import ProtectedRoute from "./common/ProtectedRoute"; 
import Topbar from "./scenes/global/Topbar";
import Sidebar from "./scenes/global/Sidebar";

import UserAccounts from "./scenes/useraccounts";
import Subscriptions from "./scenes/subscriptions";

import Landing from "./pages/landing";
import Login from "./pages/login";
import Logout from "./pages/logout";
import Reset from "./pages/reset";
import Signup from "./pages/signup";
import ContactUs from "./pages/contactus";
import Subscribe from "./pages/subscribe";
import Pricing from "./pages/pricing";
import CheckoutSuccess from "./pages/subscribe/steps/checkoutsuccess";
import CheckoutCancelled from "./pages/subscribe/steps/checkoutcancel";
import CheckoutSuccessDodo from "./pages/subscribe/steps/checkoutsuccessdodo";
import CheckoutCancelledDodo from "./pages/subscribe/steps/checkoutcanceldodo";

import ConfirmMarketingOptIn from "./pages/confirmmarketingoptin";

import PaidMarketingLandingPage from "./pages/paidmarketinglandingpage";

import PaidMarketingLandingPageReddit from "./pages/paidmarketinglandingpagereddit";

import  OptOutOfMarketingEmails from "./pages/optoutmarketingemails";

import  OptOutOfPPCMarketingEmails from "./pages/optoutppcmarketingemails";

import  DemoPage from "./pages/demopage";

import TermsOfService from "./pages/termsofservice";

import Dashboard from "./scenes/dashboard";

import Unauthorized from "./scenes/unauthorized";

import NotFound from "./pages/pagenotfound";

import VendorManagement from "./scenes/vendormanagement";
import Customers from "./scenes/customers";
import Ingredients from "./scenes/ingredients";
import MenuItems from "./scenes/menuitems";
import EventStaff from "./scenes/eventstaff";
import Equipments from "./scenes/equipments";
import VendorContracts from "./scenes/vendorcontracts";
import Events from "./scenes/events";
import EventsByStatus from "./scenes/events/indexByStatus";
import CustomerFeedback from "./scenes/customerfeedback";
import FinancialReports from "./scenes/financialreports";
import FinancialReportsByReportType from "./scenes/financialreports/indexByReportType";
import CateringOrders from "./scenes/cateringorders";
import CateringOrdersByOrderStatus from "./scenes/cateringorders/indexByOrderStatus";
import CateringOrdersByPaymentStatus from "./scenes/cateringorders/indexByPaymentStatus";
import CateringOrdersByPaymentMethod from "./scenes/cateringorders/indexByPaymentMethod";
import Billing from "./scenes/billing";
import BillingByPaymentMethod from "./scenes/billing/indexByPaymentMethod";
import BillingByPaymentStatus from "./scenes/billing/indexByPaymentStatus";


import ToastMessageDisplay from "./common/ToastMessageDisplay"; 
import { UserProvider } from "./common/UserContext";
import { ApplicationModeProvider } from "./common/ApplicationModeContext";
import { UserCountProvider } from "./common/UserCountContext";
import { AccountProvider } from "./common/AccountContext";

import Bar from "./scenes/bar";
import Line from "./scenes/line";
import Pie from "./scenes/pie";
import Geography from "./scenes/geography";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { ColorModeContext, useMode } from "./theme";
import Calendar from "./scenes/calendar/calendar";
import { Navigate } from "react-router-dom";

function App() {
  const [theme, colorMode] = useMode();
  const [isSidebar, setIsSidebar] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");  // Add this line to hold the search term
  const location = useLocation();

  const publicPaths = ["/", 
    "/index.html", 
    "/login", 
    "/logout", 
    "/reset", 
    "/signup",
    "/contactus", 
    "/subscribe", 
    "/pricing", 
    "/terms-of-service", 
    "/confirm-marketing-opt-in",
    "/opt-out-of-marketing-emails",
    "/opt-out-of-ppc-marketing-emails",
    "/checkout-success", 
    "/checkout-cancelled",
    "/checkout-dodo-success", 
    "/checkout-dodo-cancelled",

    "/not-found",
    "/limited-time-discount-offer",
    "/demo",
    "/i-built-a-tool"];

  const isPublic = publicPaths.includes(location.pathname);

/************************************ PUBLIC PAGES ********************************************* */

if (isPublic) {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/index.html" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/logout" element={<Logout />} />
      <Route path="/reset" element={<Reset />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/contactus" element={<ContactUs />} />
      <Route path="/subscribe" element={<Subscribe />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/terms-of-service" element={<TermsOfService />} />
      <Route path="/confirm-marketing-opt-in" element={<ConfirmMarketingOptIn />} />
      <Route path="/opt-out-of-marketing-emails" element={<OptOutOfMarketingEmails />} />
      <Route path="/opt-out-of-ppc-marketing-emails" element={<OptOutOfPPCMarketingEmails />} />
      <Route path="/limited-time-discount-offer" element={<PaidMarketingLandingPage />} />
      <Route path="/i-built-a-tool" element={<PaidMarketingLandingPageReddit />} />
      <Route path="/demo" element={<DemoPage />} />

      <Route path="/checkout-success" element={<CheckoutSuccess />} />
      <Route path="/checkout-cancelled" element={<CheckoutCancelled />} />
      <Route path="/checkout-dodo-success" element={<CheckoutSuccessDodo />} />
      <Route path="/checkout-dodo-cancelled" element={<CheckoutCancelledDodo />} />

      <Route path="/not-found" element={<NotFound />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

/************************************ PRIVATE PAGES ********************************************* */

  return (
    <ApplicationModeProvider>  
      <UserProvider>
        <UserCountProvider>
          <AccountProvider>
            <ColorModeContext.Provider value={colorMode}>
              <ThemeProvider theme={theme}>
                <CssBaseline />
                <div className="app">
                  <Sidebar isSidebar={isSidebar} />
                  <main className="content">
                    <Topbar setIsSidebar={setIsSidebar} searchTerm={searchTerm} setSearchTerm={setSearchTerm}/>
                    <Routes>
                      <Route path="/app" element={<ProtectedRoute element={<Dashboard />} />} />

                      <Route path="/vendormanagement" element={<ProtectedRoute element={<VendorManagement searchTerm={searchTerm} />} />} />
<Route path="/customers" element={<ProtectedRoute element={<Customers searchTerm={searchTerm} />} />} />
<Route path="/ingredients" element={<ProtectedRoute element={<Ingredients searchTerm={searchTerm} />} />} />
<Route path="/menuitems" element={<ProtectedRoute element={<MenuItems searchTerm={searchTerm} />} />} />
<Route path="/eventstaff" element={<ProtectedRoute element={<EventStaff searchTerm={searchTerm} />} />} />
<Route path="/equipments" element={<ProtectedRoute element={<Equipments searchTerm={searchTerm} />} />} />
<Route path="/vendorcontracts" element={<ProtectedRoute element={<VendorContracts searchTerm={searchTerm} />} />} />
<Route path="/vendorcontracts/list" element={<ProtectedRoute element={<VendorContracts searchTerm={searchTerm} />} />} />
<Route path="/events" element={<ProtectedRoute element={<Events searchTerm={searchTerm} />} />} />
<Route path="/events/list" element={<ProtectedRoute element={<Events searchTerm={searchTerm} />} />} />
<Route path="/events/status" element={<ProtectedRoute element={<EventsByStatus searchTerm={searchTerm} />} />} />
<Route path="/customerfeedback" element={<ProtectedRoute element={<CustomerFeedback searchTerm={searchTerm} />} />} />
<Route path="/customerfeedback/list" element={<ProtectedRoute element={<CustomerFeedback searchTerm={searchTerm} />} />} />
<Route path="/financialreports" element={<ProtectedRoute element={<FinancialReports searchTerm={searchTerm} />} />} />
<Route path="/financialreports/list" element={<ProtectedRoute element={<FinancialReports searchTerm={searchTerm} />} />} />
<Route path="/financialreports/reporttype" element={<ProtectedRoute element={<FinancialReportsByReportType searchTerm={searchTerm} />} />} />
<Route path="/cateringorders" element={<ProtectedRoute element={<CateringOrders searchTerm={searchTerm} />} />} />
<Route path="/cateringorders/list" element={<ProtectedRoute element={<CateringOrders searchTerm={searchTerm} />} />} />
<Route path="/cateringorders/orderstatus" element={<ProtectedRoute element={<CateringOrdersByOrderStatus searchTerm={searchTerm} />} />} />
<Route path="/cateringorders/paymentstatus" element={<ProtectedRoute element={<CateringOrdersByPaymentStatus searchTerm={searchTerm} />} />} />
<Route path="/cateringorders/paymentmethod" element={<ProtectedRoute element={<CateringOrdersByPaymentMethod searchTerm={searchTerm} />} />} />
<Route path="/billing" element={<ProtectedRoute element={<Billing searchTerm={searchTerm} />} />} />
<Route path="/billing/list" element={<ProtectedRoute element={<Billing searchTerm={searchTerm} />} />} />
<Route path="/billing/paymentmethod" element={<ProtectedRoute element={<BillingByPaymentMethod searchTerm={searchTerm} />} />} />
<Route path="/billing/paymentstatus" element={<ProtectedRoute element={<BillingByPaymentStatus searchTerm={searchTerm} />} />} />


                      <Route path="/pie" element={<ProtectedRoute element={<Pie />} />} />
                      <Route path="/line" element={<ProtectedRoute element={<Line />} />} />
                      <Route path="/calendar" element={<ProtectedRoute element={<Calendar />} />} />
                      <Route path="/geography" element={<ProtectedRoute element={<Geography />} />} />

                      <Route path="/useraccounts" element={<ProtectedRoute element={<UserAccounts />} role="admin" />} />
                      <Route path="/subscriptions" element={<ProtectedRoute element={<Subscriptions />} role="admin" />} />

                      <Route path="/unauthorized" element={<ProtectedRoute element={<Unauthorized />} />} />

                      <Route path="*" element={<Navigate to="/not-found" replace />} />

                    </Routes>
                    <ToastMessageDisplay />
                  </main>
                </div>
              </ThemeProvider>
            </ColorModeContext.Provider>
            </AccountProvider>
        </UserCountProvider>
      </UserProvider>
    </ApplicationModeProvider>
  );
}

export default App;
